import React from 'react';
import throttle from 'lodash.throttle';
import debounce from 'lodash.debounce';
import bindAll from 'lodash.bindall';
import event, {EVENTS} from '../lib/event';

class BlockHightlight extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            screenInfo: [document.body.clientWidth, document.body.clientHeight],
            left: 0,
            top: 0,
            height: 0,
            width: 0
        };
        bindAll(this, [
            'updateScreenInfo',
            'updateRect'
        ]);
        this.throttleUpdateScreenInfo = throttle(this.updateScreenInfo, 200);
        this.debounceUpdateRect = debounce(this.updateRect, 50);
    }
    componentDidMount () {
        window.addEventListener('resize', this.throttleUpdateScreenInfo);
        window.addEventListener('keyup', this.debounceUpdateRect);
        window.addEventListener('keydown', this.updateRect);
        this.updateRect();
    }
    componentWillUnmount () {
        window.removeEventListener('resize', this.throttleUpdateScreenInfo);
        window.removeEventListener('keyup', this.debounceUpdateRect);
        window.removeEventListener('keydown', this.updateRect);
    }
    updateRect () {
        const {left, top, width, height} = this.props.getCurrentRect();
        this.setState({
            left,
            top,
            width,
            height
        });
    }
    updateScreenInfo () {
        this.setState({
            screenInfo: [window.appTarget.clientWidth, window.appTarget.clientHeight],
        });
    }
    render () {
        const {left, top, height, width, screenInfo} = this.state;
        const offsetLeft = left - document.querySelector('[class^="gui_editor"]').getBoundingClientRect().left;
        const offsetWidth = document.querySelector('[class^="gui_editor"]').clientWidth + document.querySelector('[class^="gui_stage-and-target-wrapper"]').clientWidth

        return (
            <svg
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: offsetWidth,
                    height: '100%',
                    zIndex: this.props.zIndex || 99,
                    fillOpacity: this.props.opacity == undefined ? .3 : this.props.opacity,
                    transition: 'all .3s ease-out,height 0s 0s,opacity .3s 0s',
                    pointerEvents: this.props.pointerEvents || 'none'
                }}
                onClick={() => {
                    event.emit(EVENTS.BG_CLICK);
                }}
            >
                <path
                    style={{
                        pointerEvents: 'all',
                    }}
                    // eslint-disable-next-line max-len
                    d={`M${offsetWidth},${screenInfo[1]}H0V0H${offsetWidth}V${screenInfo[1]}ZM${offsetLeft},${top}a0,0,0,0,0-0,0V${top + height}a0,0,0,0,0,0,0H${offsetLeft + width}a0,0,0,0,0,0-0V${top}a0,0,0,0,0-0-0Z`}
                />
            </svg>
        );
    }
}

export default BlockHightlight;
